module.exports = __webpack_public_path__ + "static/logo-54175d9ca14bd3d2bf0faa513d75c113.svg";